import { useHandler } from "@redotech/react-util/hook";
import ArrowLeft from "@redotech/redo-icons/arrow-left.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import ChatBubbleIcon from "@redotech/redo-web/icon-old/chat-bubble.svg";
import { Text } from "@redotech/redo-web/text";
import * as darkModeCss from "@redotech/redo-web/theme/component-colors-dark.module.css";
import { memo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import * as css from "./merchant-app-404-page.module.css";

export const MerchantApp404Page = memo(function MerchantApp404Page() {
  const location = useLocation();
  const navigate = useNavigate();
  const intercom = useIntercom();

  useEffect(() => {
    console.error("Route not found at location", location.pathname);
  }, [location]);

  const handleGoBack = useHandler(() => {
    navigate(-1);
  });

  const handleChatWithSupport = useHandler(() => {
    intercom.showNewMessage();
  });

  return (
    <div className={css.container}>
      <img
        alt="404 Error"
        className={css.backgroundImage}
        src="https://assets.getredo.com/platform/404-image.jpg"
      />
      <Flex className={darkModeCss.darkMode} dir="column" style={{ zIndex: 2 }}>
        <h1 className={css.title}>Lost in the void</h1>
        <Text fontSize="md" textColor="primary">
          404: The page you were looking for could not be found.
        </Text>
        <Flex align="flex-start" dir="column" gap="none">
          <RedoButton
            hierarchy="link"
            IconLeading={ChatBubbleIcon}
            onClick={handleChatWithSupport}
            size="xl"
            text="Chat with us"
          />
          <RedoButton
            hierarchy="secondary"
            IconLeading={ArrowLeft}
            onClick={handleGoBack}
            size="xl"
            text="Go back"
          />
        </Flex>
      </Flex>
    </div>
  );
});
